import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpDeleteTreatmentRequest} from './treatment-requests.http'
import {MUTATION_KEYS} from '@/queryClient'

export const useDeleteTreatmentRequest = (
    treatmentRequestId: string,
    options?: Omit<UseMutationOptions, 'mutationFn'>
) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.DELETE_TREATMENT_REQUEST],
        mutationFn: () => httpDeleteTreatmentRequest({urlParams: {treatmentRequestId}}),
        ...options
    })
